import { MaterialType } from "../../../../types/materials";
import { MaterialOption } from "./types";

export const otherMaterial = "otherMaterial";

export const materialsOptions: MaterialOption[] = [...Object.values(MaterialType), otherMaterial];
